import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import { Building, Calendar2, Cash, GiftFill, Percent, Person, PhoneFill, TextParagraph } from "react-bootstrap-icons";

export default function TransactionInfos({ codetransaction }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [nomclient, setnomclient] = useState("");
    const [telclient, settelclient] = useState("");
    const [libsouscription, setlibsouscription] = useState("");
    const [libtypesouscription, setlibtypesouscription] = useState("");
    const [profilesouscription, setprofilesouscription] = useState("");
    const [photosouscription, setphotosouscription] = useState("");

    const [refint, setrefint] = useState("");
    const [pack, setpack] = useState("");
    const [montant, setmontant] = useState("");
    const [montantpercu, setmontantpercu] = useState("");
    const [commission, setcommission] = useState("");
    const [codeint, setcodeint] = useState("");
    const [operateur, setoperateur] = useState("");
    const [refoperateur, setrefoperateur] = useState("");
    const [devise, setdevise] = useState("");
    const [desc, setdesc] = useState("");
    const [codeforfait, setcodeforfait] = useState(null);
    const [codeabonnement, setcodeabonnement] = useState(null);

    const [etatdef, setetatdef] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [etat, setEtat] = useState(0);


    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${codetransaction}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setnomclient(body?.nom !== null ? body?.nom : "");
                        settelclient(body?.numtel !== null ? body?.numtel : "");

                        setcodeabonnement(body?.codeabonnement !== null ? body?.codeabonnement : null);
                        setcodeforfait(body?.codeforfait !== null ? body?.codeforfait : null);

                        if (body?.codeforfait !== null) {
                            setlibsouscription(body?.lib !== null ? body?.lib : "");
                            setlibtypesouscription(body?.libtforfait !== null ? body?.libtforfait : "");
                            setprofilesouscription(body?.profileforfait !== null ? body?.profileforfait : "");
                            setphotosouscription(body?.imgforfait !== null ? body?.imgforfait : "/assets/imgs/no-image.png");
                        } else {
                            setlibsouscription(body?.libabonnement !== null ? body?.libabonnement : "");
                            setlibtypesouscription(body?.libtabonnement !== null ? body?.libtabonnement : "");
                            setprofilesouscription(body?.pack !== null ? body?.pack : "");
                            setphotosouscription(body?.imgabonnement !== null ? body?.imgabonnement : "/assets/imgs/no-image.png");
                        }


                        // setmodepayement(body?.modepayement !== null ? body?.modepayement : "");
                        setrefint(body?.refint !== null ? body?.refint : "");
                        setpack(body?.pack !== null ? body?.pack : "");
                        setmontant(body?.montant !== null ? body?.montant : "");
                        setmontantpercu(body?.montantpercu !== null ? body?.montantpercu : "");
                        setcommission(body?.commint !== null ? body?.commint : "");
                        setcodeint(body?.codeint !== null ? body?.codeint : "");
                        setoperateur(body?.operateur !== null ? body?.operateur : "");
                        setrefoperateur(body?.refop !== null ? body?.refop : "");
                        setdevise(body?.devise !== null ? body?.devise : "");
                        setdesc(body?.descr !== null ? body?.descr : "");

                        setetatdef(body?.etatdef !== null ? body?.etatdef : "");
                        setEtat(body?.etat !== null ? body?.etat : 0);

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 16).replace("T", " à ") : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    // comportements
    useEffect(() => {
        getElement();
    }, []);



    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        <h5 className="m-0 ">
                                            {textes.fr.transactioninfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form
                                            style={{ width: "100%" }}
                                            className="mb-3"
                                            onSubmit={() => { }}
                                        >
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-3 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <img alt="" src={"/assets/imgs/blank.png"} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="nomclient" className="mb-1">CLient</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="nomclient">
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nomclient}
                                                                    onChange={(e) =>
                                                                        setnomclient(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="telclient" className="mb-1">Numéro de téléphone</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="telclient">
                                                                    <PhoneFill />
                                                                </span>
                                                                <input
                                                                    type="tel"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={telclient}
                                                                    onChange={(e) =>
                                                                        settelclient(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <img alt="" src={photosouscription} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="libsouscription" className="mb-1">{codeabonnement !== null ? "Abonnement" : "Forfait"}</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="libsouscription">
                                                                    <GiftFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={libsouscription + " (" + libtypesouscription + ")"}
                                                                    onChange={(e) =>
                                                                        setlibsouscription(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="profilesouscription" className="mb-1">Profil</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="profilesouscription">
                                                                    <GiftFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={profilesouscription}
                                                                    onChange={(e) =>
                                                                        setprofilesouscription(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-0">
                                                            <h6 className="m-0">{textes.fr.statelabel} de la transaction</h6>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <span
                                                                className={`badge ${etat === 1 ? "badge-info" :
                                                                    etat === 2 ? "badge-warning" :
                                                                        etat === 3 ? "badge-danger" :
                                                                            etat === 4 ? "badge-success" :
                                                                                ""
                                                                    } w-100 mt-2`
                                                                }
                                                                style={{ fontSize: 18, padding: "24px 16px", color: etat === 2 ? "#000" : "#fff" }}>
                                                                {
                                                                    etatdef !== null ? etatdef :
                                                                        "Etat"
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="montant" className="mb-1">
                                                                Montant total
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="montant"
                                                                >
                                                                    <Cash />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={montant}
                                                                    onChange={(e) =>
                                                                        setmontant(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="montantpercu" className="mb-1">
                                                                Montant Perçu
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="montantpercu"
                                                                >
                                                                    <Cash />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={montantpercu}
                                                                    onChange={(e) =>
                                                                        setmontantpercu(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="operateur" className="mb-1">
                                                                Opérateur
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="operateur"
                                                                >
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={operateur}
                                                                    onChange={(e) =>
                                                                        setoperateur(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="commission" className="mb-1">
                                                                Commission
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="commission"
                                                                >
                                                                    <Percent />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={commission}
                                                                    onChange={(e) =>
                                                                        setcommission(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="refint" className="mb-1">
                                                                Reférence Intégrateur
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="refint"
                                                                >
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={refint}
                                                                    onChange={(e) =>
                                                                        setrefint(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>}
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="refoperateur" className="mb-1">
                                                                Reférence opérateur
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="refoperateur"
                                                                >
                                                                    <Percent />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={refoperateur}
                                                                    onChange={(e) =>
                                                                        setrefoperateur(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>}
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                Date Transaction
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
